import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { EmailConsentModal } from './EmailConsentModal';

export const EmailConsentBanner: React.FC = () => {
  const { isAuthenticated, hasEmailConsent } = useAuth();
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    // Check if modal should auto-open
    if (!isAuthenticated) return;
    if (hasEmailConsent()) return;

    // Check if already shown this session
    const shownThisSession = sessionStorage.getItem('emailConsentModalShown') === 'true';
    if (shownThisSession) return;

    // Show modal after a short delay (let page load first)
    const timer = setTimeout(() => {
      setIsModalOpen(true);
      sessionStorage.setItem('emailConsentModalShown', 'true');
    }, 1500); // 1.5 second delay

    return () => clearTimeout(timer);
  }, [isAuthenticated, hasEmailConsent]);

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <EmailConsentModal
      isOpen={isModalOpen}
      onClose={handleCloseModal}
      initialMarketing={false}
      initialProduct={true}
      initialExpiration={true}
    />
  );
};
